export const StrategiesEnum = {
  scale: "Scale",
  optimize: "Optimize",
  maintain: "Maintain",
};
